/* Current Nostalgia - search results page (v94), loaded by sections/main-search. The shared part
   (assets/cn-search.js, in the header) reads a search; this part:
   - redirects a plain /search?q= link to the read search (the loose results are held back until
     it decides - see the cn-sq-pending guard in sections/main-search);
   - shows what the search was read as - removable chips - and "Search everything" (cn=0);
   - applies the size: tiles in other sizes are hidden, grouped tiles open that size, and the other
     result pages are pulled in so nothing in that size is missed; Brand / type filter changes
     keep the read search;
   - when nothing is found, offers the nearest search that finds something. */
(function () {
  if (window.__cnSearchPage) return;
  window.__cnSearchPage = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEEP = ['cn', 'cn_size', 'cn_q'];
  var S, parse, buildUrl, plainUrl, typeLabel, sizeLabel, norm, esc;

  function onSearchPage() { return /\/search\/?$/.test(location.pathname); }
  function unpend() { document.documentElement.classList.remove('cn-sq-pending'); }

  var EQ = { '28': 'xs', '30': 's', '32': 'm', '34': 'l', '36': 'xl', '38': 'xxl' };
  var EQR = {};
  Object.keys(EQ).forEach(function (k) { EQR[EQ[k]] = k; });
  function sizeHit(attr, s) {
    var hay = ' ' + (attr || '') + ' ';
    if (hay.indexOf(' ' + s + ' ') > -1) return true;
    var alt = EQ[s] || EQR[s];
    return alt ? hay.indexOf(' ' + alt + ' ') > -1 : false;
  }
  function tileKey(li) {
    var chips = Array.prototype.map.call(li.querySelectorAll('a.cn-sizes__s[href]'), function (a) {
      return a.getAttribute('href').split('?')[0];
    }).sort();
    if (chips.length) return chips.join('|');
    var a = li.querySelector('a[href*="/products/"]');
    return a ? (a.getAttribute('data-cn-orig') || a.getAttribute('href')).split('?')[0] : '';
  }
  function urlWithout(params, drop) {
    var u = new URLSearchParams(params.toString());
    u.delete('page');
    Object.keys(drop).forEach(function (k) {
      if (drop[k] === true) { u.delete(k); return; }
      var keep = u.getAll(k).filter(function (v) { return v !== drop[k]; });
      u.delete(k);
      keep.forEach(function (v) { u.append(k, v); });
    });
    /* a read search with nothing left to read is just the plain search */
    var left = u.getAll('filter.p.vendor').length + u.getAll('filter.p.product_type').length + (u.get('cn_size') ? 1 : 0);
    if (!left && u.get('cn_q')) return plainUrl(u.get('cn_q'));
    /* the brand was the whole search: search for what's left of what they typed instead */
    if (drop['filter.p.vendor'] && norm(u.get('q')) === norm(drop['filter.p.vendor'])) {
      var p0 = parse(u.get('cn_q') || '');
      u.set('q', (p0 && p0.rest) || u.getAll('filter.p.vendor')[0] || (p0 && p0.typeText) || u.get('cn_q') || u.get('q'));
    }
    return ROOT + 'search?' + u.toString();
  }

  function typesLabel(types) {
    var g = typeLabel(types);
    var each = types.map(function (t) { return typeLabel([t]); });
    var uniq = each.filter(function (x, i) { return each.indexOf(x) === i; });
    return uniq.length > 1 && types.length <= 3 && uniq[0] === g ? uniq.join(' / ') : g;
  }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? v : '$' + (n % 1 ? n.toFixed(2) : n); }
  function sizeText(size) { return size === 'os' ? 'one size' : 'size ' + sizeLabel(size); }

  /* the read search's chips stand in for Shopify's own filter pills, so every active filter
     gets one: brand, type, size, and any availability or price picked in Filter and sort */
  function renderBar() {
    var params = new URLSearchParams(location.search);
    var head = document.querySelector('.template-search__header');
    if (!head) return;
    var old = head.querySelector('[data-cn-sq]');
    if (old) old.remove();
    if (params.get('cn') !== '1') return;
    document.documentElement.classList.add('cn-sq-on');
    var chips = [];
    params.getAll('filter.p.vendor').forEach(function (v) {
      chips.push([v, urlWithout(params, { 'filter.p.vendor': v })]);
    });
    var types = params.getAll('filter.p.product_type');
    if (types.length) chips.push([typesLabel(types), urlWithout(params, { 'filter.p.product_type': true })]);
    var size = params.get('cn_size');
    if (size) chips.push(['Size ' + sizeLabel(size), urlWithout(params, { cn_size: true })]);
    params.getAll('filter.v.availability').forEach(function (v) {
      chips.push([v === '1' ? 'In stock' : 'Sold out', urlWithout(params, { 'filter.v.availability': v })]);
    });
    var lo = params.get('filter.v.price.gte'), hi = params.get('filter.v.price.lte');
    if (lo || hi) {
      chips.push([lo && hi ? money(lo) + '–' + money(hi) : lo ? money(lo) + '+' : 'Up to ' + money(hi),
        urlWithout(params, { 'filter.v.price.gte': true, 'filter.v.price.lte': true })]);
    }
    var original = params.get('cn_q') || params.get('q') || '';
    var html = '<div class="cn-sq" data-cn-sq><span class="cn-sq__k">Showing</span><ul class="cn-sq__chips" role="list">';
    chips.forEach(function (c) {
      html += '<li><a class="cn-sq__chip" href="' + esc(c[1]) + '" aria-label="Remove ' + esc(c[0]) + '">' + esc(c[0]) +
        '<svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.4"/></svg></a></li>';
    });
    html += '</ul>';
    if (original) html += '<a class="cn-sq__all" href="' + esc(plainUrl(original)) + '">Search everything for “' + esc(original) + '”</a>';
    html += '</div>';
    var form = head.querySelector('.template-search__search');
    if (form) form.insertAdjacentHTML('afterend', html); else head.insertAdjacentHTML('beforeend', html);
  }

  /* size: hide other sizes, point grouped tiles at it, pull in the other result pages */
  var sizeRun = 0;
  function sizeFilter() {
    var params = new URLSearchParams(location.search);
    var size = (params.get('cn_size') || '').toLowerCase();
    var wrap = document.getElementById('product-grid');
    if (!size || !wrap) return;
    var list = wrap.querySelector('ul.product-grid');
    if (!list || list.getAttribute('data-cn-sized') === size) return;
    list.setAttribute('data-cn-sized', size);
    var run = ++sizeRun;
    var keys = {};
    var shown = 0;
    function take(li, append) {
      var k = tileKey(li);
      if (!sizeHit(li.getAttribute('data-cn-sizes'), size) || (k && keys[k])) {
        if (!append) li.hidden = true;
        return;
      }
      if (k) keys[k] = true;
      if (append) {
        li.classList.remove('scroll-trigger', 'animate--slide-in');
        list.appendChild(li);
      }
      li.hidden = false;
      if (li.hasAttribute('data-cn-dest') && window.cnPointTile) window.cnPointTile(li, size);
      shown++;
    }
    Array.prototype.slice.call(list.querySelectorAll(':scope > li.grid__item')).forEach(function (li) { take(li, false); });

    var pager = wrap.querySelector('.pagination-wrapper, nav.pagination');
    var pages = 1;
    if (pager) {
      pager.querySelectorAll('a, span').forEach(function (el) {
        var n = parseInt(el.textContent.trim(), 10);
        if (n > pages) pages = n;
      });
    }
    var current = parseInt(params.get('page'), 10) || 1;
    var sectionId = wrap.getAttribute('data-id');
    var todo = [];
    for (var p = 1; p <= Math.min(pages, 8); p++) if (p !== current) todo.push(p);
    if (todo.length && pager) pager.hidden = true;
    function finish() {
      if (run !== sizeRun) return;
      var txt = shown + (shown === 1 ? ' piece' : ' pieces') + ' in ' + sizeText(size);
      ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.textContent = txt;
      });
      var old = wrap.querySelector('[data-cn-sq-empty]');
      if (old) old.remove();
      if (!shown) {
        var all = urlWithout(params, { cn_size: true });
        list.insertAdjacentHTML('afterend', '<div class="cn-sq-empty" data-cn-sq-empty>' +
          '<p class="cn-sq-empty__t">Nothing in ' + esc(sizeText(size)) + ' right now.</p>' +
          '<p>Almost everything here is one of one, so sizes come and go. <a href="' + esc(all) + '">See every size</a></p></div>');
      }
    }
    if (!todo.length || !sectionId) { finish(); return; }
    (function next(k) {
      if (run !== sizeRun) return;
      if (k >= todo.length) { finish(); return; }
      var u = new URLSearchParams(params.toString());
      u.set('page', String(todo[k]));
      u.set('section_id', sectionId);
      fetch(location.pathname + '?' + u.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (run !== sizeRun) return;
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          Array.prototype.slice.call(tpl.content.querySelectorAll('#product-grid ul.product-grid > li.grid__item')).forEach(function (li) {
            take(document.importNode(li, true), true);
          });
          next(k + 1);
        })
        .catch(function () { next(k + 1); });
    })(0);
  }

  /* facet and sort changes (Dawn rewrites the URL from the filter form) keep the read search */
  function keepParams() {
    if (history.__cnKeep) return;
    history.__cnKeep = true;
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function (state, title, url) {
        try {
          if (url != null) {
            var u = new URL(url, location.href);
            var cur = new URLSearchParams(location.search);
            if (/\/search\/?$/.test(u.pathname)) {
              KEEP.forEach(function (k) {
                if (!u.searchParams.has(k) && cur.get(k)) u.searchParams.set(k, cur.get(k));
              });
              url = u.pathname + u.search + u.hash;
            }
          }
        } catch (e) {}
        var r = orig.apply(this, [state, title, url]);
        setTimeout(function () { renderBar(); sizeFilter(); }, 0);
        return r;
      };
    });
    window.addEventListener('popstate', function () { setTimeout(function () { renderBar(); sizeFilter(); }, 0); });
    var box = document.getElementById('ProductGridContainer');
    if (box && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(sizeFilter, 60); })
        .observe(box, { childList: true, subtree: true });
    }
  }

  /* ---------- nothing found: offer the nearest search that finds something ---------- */
  function countIn(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var c = d.getElementById('ProductCountDesktop') || d.getElementById('ProductCount');
    var m = c && c.textContent.match(/(\d+)/);
    if (m) return parseInt(m[1], 10);
    return d.querySelectorAll('#product-grid li.grid__item').length;
  }
  function rescue() {
    var box = document.querySelector('[data-cn-rescue]');
    if (!box || box.getAttribute('data-done')) return;
    box.setAttribute('data-done', '1');
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    var original = params.get('cn_q') || q;
    var title = document.querySelector('[data-cn-sx-q]');
    if (title && original) title.textContent = original;
    var tries = [];
    if (params.get('cn') === '1') {
      var vendors = params.getAll('filter.p.vendor'), types = params.getAll('filter.p.product_type');
      var base = { original: original, size: params.get('cn_size') || '' };
      if (vendors.length || types.length) {
        var simple = vendors[0] || types[0];
        if (simple && norm(simple) !== norm(q)) tries.push([buildUrl({ original: original, q: simple, vendor: vendors[0] || '', types: types, size: base.size }), 'everything that matches ' + [vendors[0], types.length ? typeLabel(types).toLowerCase() : ''].filter(Boolean).join(' ')]);
        if (vendors.length && types.length) tries.push([buildUrl({ original: original, q: vendors[0], vendor: vendors[0], types: [], size: base.size }), 'all ' + vendors[0]]);
        if (vendors.length && types.length) tries.push([buildUrl({ original: original, q: types[0], vendor: '', types: types, size: base.size }), 'all ' + typeLabel(types).toLowerCase()]);
      }
      tries.push([plainUrl(original), '“' + original + '” across the whole shop']);
    } else if (q) {
      var w = q.split(/\s+/).filter(Boolean);
      if (w.length > 1) {
        tries.push([plainUrl(w.slice(0, -1).join(' ')), '“' + w.slice(0, -1).join(' ') + '”']);
        tries.push([plainUrl(w[0]), '“' + w[0] + '”']);
      }
    }
    (function next(i) {
      if (i >= tries.length) return;
      fetch(tries[i][0], { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var n = html ? countIn(html) : 0;
          if (!n) return next(i + 1);
          box.innerHTML = '<a class="cn-sx__rescue" href="' + esc(tries[i][0]) + '">See ' + n + ' result' + (n === 1 ? '' : 's') +
            ' for ' + esc(tries[i][1]) + ' <span aria-hidden="true">→</span></a>';
          box.hidden = false;
        })
        .catch(function () { next(i + 1); });
    })(0);
  }

  function run() {
    S = window.cnSearch;
    if (!onSearchPage() || !S) { unpend(); return; }
    parse = S.parse; buildUrl = S.buildUrl; plainUrl = S.plainUrl; typeLabel = S.typeLabel;
    sizeLabel = S.sizeLabel; norm = S.norm; esc = S.esc;
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    var hasFilter = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    var type = params.get('type');
    if (q && !params.has('cn') && !hasFilter && (!type || type === 'product')) {
      var p = parse(q);
      if (p) { location.replace(buildUrl(p)); return; }
    }
    unpend();
    if (params.get('cn') === '1') {
      /* the box shows what they typed, not the shortened search it was read as - while the
         filters are still the ones it was read into */
      var box = document.getElementById('Search-In-Template');
      var p0 = box && parse(params.get('cn_q') || '');
      if (p0 && p0.vendor === (params.get('filter.p.vendor') || '') &&
          p0.types.join('|') === params.getAll('filter.p.product_type').join('|') &&
          p0.size === (params.get('cn_size') || '')) box.value = p0.original;
      renderBar();
      sizeFilter();
      keepParams();
    }
    rescue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();